import styled from 'styled-components';

export const POLICY_LEVEL = {
  ORDER: 'order',
  ITEM: 'item',
};

export const PolicyLevelTabs = [
  {
    key: POLICY_LEVEL.ITEM,
    title: 'Item Level',
  },
  {
    key: POLICY_LEVEL.ORDER,
    title: 'Order Level',
  },
];

// Endpoints for complaint type policy CRUD operations
export const COMPLAINT_TYPE_POLICY_ENDPOINTS = {
  STATUS: 'admin/complaint_type_policy/status_policy',
  CREATE: 'admin/complaint_type_policy/create_policy',
  FETCH: 'admin/complaint_type_policy/fetch_policy',
  UPDATE: 'admin/complaint_type_policy/update_policy',
  DELETE: 'admin/complaint_type_policy/delete_policy',
  RESPAWN: 'admin/complaint_type_policy/respawn_policy',
};

// Policy status result cases
export const POLICY_STATUS = {
  NONE: 'NONE', // initial state, no status check done yet
  EXISTS: 'EXISTS', // exists=true, is_deleted=false
  DELETED: 'DELETED', // exists=true, is_deleted=true
  NOT_FOUND: 'NOT_FOUND', // exists=false
};

export const SKELETON_ROWS = [
  { cols: 1, height: '2.4rem', width: '200px' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 1, height: '3.6rem', width: '130px' },
];

export const multiSelectStyles = `
  .searchWrapper .search-wrapper {
    max-height: 100rem !important;
    height: 100px !important;
    z-index: -1 !important;
  }
  .option:hover {
    background-color: #318616 !important;
  }
  .chip {
    border-radius: 0.6rem !important;
  }
`;

export const tabStyles = `
  hr {
    background-color: #318616 !important;
    height: 4px;
    border-radius: 4px 4px 0px 0px !important;
    margin:0;
  }
  h2 {
    border: none !important;
  }
`;

export const TabsSectionWrapper = styled.div`
  > section {
    min-height: 0 !important;
    margin-top: 5px;
  }
`;
